import { Provider } from '@angular/core';

import { PhoneService } from './phone.service';

export function providePhone(): Provider[] {
  return [PhoneService];
}
